import React, { useEffect, useState } from 'react';
import { fetchAPI, getStrapiMedia } from '../../utils/api';

const ResourceList = () => {
	const [resources, setResources] = useState([]);

	useEffect(() => {
		const getResources = async () => {
			try {
				// Fetching from the resources endpoint
				const response = await fetchAPI('/resources', {
					populate: {
						file: true // Populating the media field
					},
					sort: 'createdAt:desc'
				});

				if (response.data) {
					const mappedResources = response.data.map(item => {
						// Resource schema: title, slug, description, file
						const files = item.file || [];
						const primaryFile = files.length > 0 ? files[0] : null;

						return {
							id: item.id,
							documentId: item.documentId,
							title: item.title,
							description: item.description,
							// Use the first file as the card image
							image: primaryFile ? getStrapiMedia(primaryFile) : '/img/placeholder.jpg',
							// The direct link to the file for downloading
							downloadUrl: primaryFile ? `${getStrapiMedia(primaryFile)}` : null,
							fileName: primaryFile ? primaryFile.name : 'resource',
							date: item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'Recent'
						};
					});
					setResources(mappedResources);
				}
			} catch (error) {
				console.error("Error fetching resources:", error);
			}
		};
		getResources();
	}, []);

	return (
		<div className="row items">
			{resources.map(resource => (
				<div key={resource.documentId || resource.id} className="col-12 col-md-6 col-lg-4 item">
					<div className="card blog-item">

						<div className="card-content mt-3">
							<div className="heading">
								<div className="post-meta d-flex">
									<span className="post-date">
										<i className="bi bi-calendar-check me-1"></i>{resource.date}
									</span>
								</div>
								<h4 className="title my-2">{resource.title}</h4>
								<p className="description mb-3">
									{resource.description}
								</p>

								{/* Download Button */}
								{resource.downloadUrl && (
									<a
										href={resource.downloadUrl}
										download={resource.fileName}
										target="_blank"
										rel="noopener noreferrer"
										className="btn btn-primary btn-sm d-inline-flex align-items-center"
									>
										<i className="bi bi-download me-2"></i>
										Download Resource
									</a>
								)}
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default ResourceList;